import React from "react";

function FilterFunnelIcon({ size = 18 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M5 7h14L13 14v5l-2 1v-6L5 7z" />
    </svg>
  );
}

/**
 * Toolbar control to open list filter slide-over / modal.
 * Pass `activeSummary` (e.g. from formatAdvancedFilterActiveSummary) so hover shows
 * the active filter conditions without opening the panel.
 */
export default function ListFiltersToolbarButton({
  onClick,
  activeCount = 0,
  disabled = false,
  title,
  activeSummary,
}) {
  const hasActive = activeCount > 0;
  const label = hasActive ? `Filters (${activeCount})` : "Filters";
  const summary =
    typeof activeSummary === "string" && activeSummary.trim() !== "" ? activeSummary.trim() : "";
  const tooltip = title != null ? title : hasActive && summary ? summary : label;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={tooltip}
      aria-label={label}
      className={
        hasActive
          ? "list-filters-toolbar-btn list-filters-toolbar-btn--active"
          : "list-filters-toolbar-btn"
      }
    >
      <FilterFunnelIcon size={18} />
      <span className="list-filters-toolbar-btn__label">{label}</span>
    </button>
  );
}
